import {toNumber, inRange} from 'lodash';
import {DataSourceFilter} from './data-source.filter';
import { Injectable } from "@angular/core";

@Injectable()
export class FilledPercentageFilter extends DataSourceFilter {
    public onFilterApplied(data: any, selectedFilledPercentageRange: string): boolean {
        const [startRange, endRange] = selectedFilledPercentageRange.split('-').map(item => toNumber(item));
        return inRange(data.filled_percentage, startRange, endRange + 1);
    }

    public identifier(): string {
        return 'FilledPercentageFilter';
    }
}
